import { httpLoansApi } from 'app/services/http';
import _ from 'lodash';

const toNullableString = value => (_.isNil(value) || value === '' ? null : value);

class CustomFieldDefinitionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCustomFieldDefinitions(params = {}) {
    return this.#http.get('/api/custom-field-definitions', { params });
  }

  async createCustomFieldDefinition(data) {
    return this.#http.post('/api/custom-field-definitions', data);
  }

  async updateCustomFieldDefinition(id, data) {
    if (!id) {
      throw new Error('Missing ID for update operation');
    }

    if (!data) {
      throw new Error('Missing data for update operation');
    }

    const sanitizedData = {
      name: data.name,
      description: toNullableString(data.description),
      expressionKey: data.expressionKey,
      target: data.target,
      valueType: data.valueType,
      isEnabled: _.isBoolean(data.isEnabled) ? data.isEnabled : false,
      companyId: data.companyId,
      isGlobal: _.isBoolean(data.isGlobal) ? data.isGlobal : false,
      valueSource: {
        type: toNullableString(data.valueSource?.type),
        expression: toNullableString(data.valueSource?.expression),
        isRequired: !!data.valueSource?.isRequired,
        readOnly: !!data.valueSource?.readOnly,
        displayInLoanEditor: _.isBoolean(data.valueSource?.displayInLoanEditor)
          ? data.valueSource.displayInLoanEditor
          : null,
      },
      defaultValue: _.isNil(data.defaultValue) ? null : data.defaultValue,
    };

    return this.#http.put(`/api/custom-field-definitions/${id}`, sanitizedData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async deleteCustomFieldDefinition(id) {
    return this.#http.delete(`/api/custom-field-definitions/${id}`);
  }

  async upsertCustomFieldDefinitionOverride(id, data) {
    if (!id) {
      throw new Error('Missing ID for override upsert');
    }

    const body = {
      isEnabled: _.isBoolean(data?.isEnabled) ? data.isEnabled : null,
      description: _.isNil(data?.description) ? null : data.description,
      defaultValue: _.isNil(data?.defaultValue) ? null : data.defaultValue,
      displayInLoanEditor: _.isBoolean(data?.displayInLoanEditor) ? data.displayInLoanEditor : null,
      expression: toNullableString(data?.expression),
    };

    return this.#http.put(`/api/custom-field-definitions/${id}/override`, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async deleteCustomFieldDefinitionOverride(id) {
    if (!id) {
      throw new Error('Missing ID for override delete');
    }

    return this.#http.delete(`/api/custom-field-definitions/${id}/override`);
  }

  async getApplicationCustomFieldValues(applicationId) {
    return this.#http.get(`/api/applications/${applicationId}/custom-fields`);
  }

  async saveManualCustomFieldValues(applicationId, values) {
    return this.#http.put(`/api/applications/${applicationId}/custom-fields/manual`, values);
  }
}

export const customFieldDefinitionsApi = new CustomFieldDefinitionsApi(httpLoansApi);
